import { Alert, Spinner } from 'react-bootstrap';
import PropTypes from 'prop-types';

function LoadingMessage({
  message = 'Please wait...',
  style,
  spinnerSize,
  fontSize,
}) {
  return (
    <Alert variant="light" style={style}>
      <Alert.Heading style={{ fontSize }}>
        <Spinner size={spinnerSize} animation="border" />
        <span style={{ marginLeft: '0.5em', padding: 0 }}>
          <i>{message}</i>
        </span>
      </Alert.Heading>
    </Alert>
  );
}

LoadingMessage.propTypes = {
  message: PropTypes.string,
  style: PropTypes.object,
  spinnerSize: PropTypes.string,
  fontSize: PropTypes.string,
};

export default LoadingMessage;
